import { Component, h } from "@lukekaalim/act"
import { PropsForTypeOfLogicEditor } from "./common"
import { html } from "@lukekaalim/act-web"

export const CharacterLogicEditor: Component<PropsForTypeOfLogicEditor<"character">> = ({ logic, onLogicDataChange }) => {
  return [
    h(html.label, {}, [
      h(html.span, {}, 'Name'),
      h(html.input, { type: 'text', value: logic.data.name, onChange(event) {
        onLogicDataChange({ name: this.value })
      }, })
    ])
  ]
}
export const HeroLogicEditor: Component<PropsForTypeOfLogicEditor<"hero">> = ({ logic, onLogicDataChange }) => {
  return [
    h(html.label, {}, [
      h(html.span, {}, 'Player'),
      // h(html.input, { type: 'text', value: logic.data.name, onChange(event) {
      //   onLogicDataChange({ name: this.value })
      // }, })
    ])
  ]
}
export const MonsterLogicEditor: Component<PropsForTypeOfLogicEditor<"monster">> = ({ logic, onLogicDataChange }) => {
  return [
    h(html.label, {}, [
      h(html.span, {}, 'Show Stats'),
      h(html.input, { type: 'checkbox', checked: logic.data.sourceRef, onChange(event) {
        onLogicDataChange({ sourceRef: this.checked })
      }, })
    ])
  ]
}
export const HitpointsLogicEditor: Component<PropsForTypeOfLogicEditor<"hitpoints">> = ({ logic, onLogicDataChange }) => {
  return [
    h(html.label, {}, [
      h(html.span, {}, 'Maximum'),
      h(html.input, { type: 'number', valueAsNumber: logic.data.maximum, onInput(event) {
        onLogicDataChange({ ...logic.data, maximum: this.valueAsNumber })
      }, style: { width: '64px' } })
    ]),
    h(html.label, {}, [
      h(html.span, {}, 'Current'),
      h(html.input, { type: 'number', valueAsNumber: logic.data.current, onInput(event) {
        onLogicDataChange({ ...logic.data, current: this.valueAsNumber })
      }, style: { width: '64px' } }),
    ]),
    h(html.progress, {
      min: 0,
      max: logic.data.maximum,
      value: logic.data.current,
      step: '1',
    }),
    h(html.label, {}, [
      h(html.span, {}, 'Temporary'),
      h(html.input, { type: 'number', valueAsNumber: logic.data.temporary,
        onInput(event) {
          onLogicDataChange({ ...logic.data, temporary: this.valueAsNumber })
        },
      })
    ]),
  ]
}